import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import heroImage from '~media/industries/saas/hero.svg'
import iconAvailability from '~media/industries/saas/availability.svg'
import iconCloud from '~media/industries/saas/cloud.svg'
import iconCustomer from '~media/industries/saas/customer.svg'
import iconPromise from '~media/industries/saas/promise.svg'
import whitepaper from '~media/industries/saas/whitepaper.svg'
import { UseCases } from '~components/industries/UseCases'
import FilteredContent from '~components/FilteredContent'
import IndustryHero from '~components/industries/IndustryHero'
import IndustryTopCTA from '~components/industries/IndustryTopCTA'
import IndustryLayout from '~components/industries/IndustryLayout'
import IndustryCaseStudies from '~components/industries/IndustryCaseStudies'

const getIcon = (icon) => {
  // eslint-disable-next-line default-case
  switch (icon) {
    case 'availability':
      return iconAvailability
    case 'cloud':
      return iconCloud
    case 'customer':
      return iconCustomer
    case 'promise':
      return iconPromise
  }
}

const Saas = ({
  data: {
    file: {
      childMdx: { frontmatter: pageData },
    },
  },
}) => (
  <IndustryLayout
    title={pageData.title}
    description={pageData.description}
    socialMediaImage={pageData.socialMediaImage}
  >
    <IndustryHero
      image={heroImage}
      heading={pageData.hero.heading}
      blurb={pageData.hero.blurb}
      seoRef="saas"
    />
    <IndustryTopCTA
      image={whitepaper}
      heading={pageData.saasWhitepaper.heading}
      cta={pageData.saasWhitepaper.cta}
    />
    <IndustryCaseStudies data={pageData.industryCaseStudies} />
    <UseCases
      heading={pageData.saasUseCases.heading}
      blurb={pageData.saasUseCases.blurb}
      useCases={pageData.saasUseCases.items}
      getIcon={getIcon}
    />
    <FilteredContent
      heading={pageData.saasDiscover.heading}
      filters="topics:SaaS"
    />
  </IndustryLayout>
)

Saas.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Saas

export const pageQuery = graphql`
  query SaasPageData {
    file(
      name: { eq: "industries__saas" }
      absolutePath: { regex: "/src/data/" }
    ) {
      childMdx {
        frontmatter {
          title
          description
          socialMediaImage
          hero {
            blurb
            heading
          }
          saasWhitepaper {
            heading
            cta {
              label
              url
            }
          }
          industryCaseStudies {
            title {
              ...CaseStudyTeaserFragment
            }
          }
          saasUseCases {
            heading
            blurb
            items {
              heading
              icon
              examples {
                blurb
              }
            }
          }
          saasDiscover {
            heading
          }
        }
      }
    }
  }
`
